import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface MiniProfile {
  name: string;
  role: 'owner' | 'installer' | 'manufacturer' | 'network';
  avatarUrl?: string;
  companyName?: string;
  description?: string;
  phone?: string;
  email?: string;
  website?: string;
}

@Component({
  selector: 'app-mini-profile',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './mini-profile.component.html',
  styleUrl: './mini-profile.component.scss',
})
export class MiniProfileComponent {
  @Input() profile: MiniProfile;

  get roleLabel(): string {
    const labels: Record<string, string> = {
      owner: 'Owner',
      installer: 'Installer',
      manufacturer: 'Manufacturer',
      network: 'Network',
    };
    return labels[this.profile?.role] || this.profile?.role;
  }

  get roleIcon(): string {
    const icons: Record<string, string> = {
      owner: 'person',
      installer: 'build',
      manufacturer: 'precision_manufacturing',
      network: 'hub',
    };
    return icons[this.profile?.role] || 'person';
  }

  get displayName(): string {
    return this.profile?.companyName || this.profile?.name || 'Unknown';
  }
}
